import Footer, { EVENT_NAMES } from './components/Footer';
import messages from './i18n/index';

export default Footer;
export { messages, EVENT_NAMES };
